import { createFileRoute } from "@tanstack/react-router";
import { PosSyncStatusCard } from "../components/settings/pos-sync/PosSyncStatusCard";
import { PosSyncAutoCard } from "../components/settings/pos-sync/PosSyncAutoCard";
import { PosSyncTriggerRow } from "../components/settings/pos-sync/PosSyncTriggerRow";
import { PosSyncReconcileCard } from "../components/settings/pos-sync/PosSyncReconcileCard";
import { PosSyncRunsTable } from "../components/settings/pos-sync/PosSyncRunsTable";

export const Route = createFileRoute("/_auth/settings/pos-sync")({
  staticData: {
    titleKey: "settings.posSync.title",
    breadcrumbKey: "breadcrumb.manage",
    breadcrumbN: 2,
  },
  component: PosSyncPage,
});

function PosSyncPage() {
  return (
    <>
      <PosSyncStatusCard />
      <PosSyncAutoCard />
      <PosSyncTriggerRow />
      <PosSyncReconcileCard />
      <PosSyncRunsTable />
    </>
  );
}
